import type { IResponseEventMessage } from 'entities/Message'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useEventMessageReceivedNewGlobal } from 'entities/Conversation/events/EventMessageReceivedNewGlobal'
import type { ContactsConversationOpenStore } from 'widgets/ContactsDetails/ui/ContactsConversationOpen'

export const useEventMessageReceivedNew = (
  contactsConversationOpenStore: ContactsConversationOpenStore
) => {
  const { conversationStore } = useEntitiesContext()
  const handler = (data: IResponseEventMessage) => {
    const conversation = conversationStore.addItem(data.conversation)
    const conversationMessageStore = contactsConversationOpenStore.conversationMessagesStore

    if (contactsConversationOpenStore.inbox?.id !== data.conversation.inbox_id) return
    if (conversationMessageStore.conversationId) return

    // Check if a contact is already selected and the incoming message is not for that contact
    const selectedContact = contactsConversationOpenStore.contact
    if (selectedContact && selectedContact.id !== data.conversation.contact_id) return

    contactsConversationOpenStore.contactsDetailsStore.setConversationId(conversation.id)

    if (data.message.conversation_id === conversationMessageStore.conversationId) {
      conversationMessageStore.setItems([data.message])
    }
  }

  useEventMessageReceivedNewGlobal(handler)
}
